import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getPagingInfo, Pagination } from '../../Pagination.js';
import { PaginationHeader } from '../../PaginationHeader.js';
import { getPageSize } from '../../../utils/pageSize.js';
import { noop } from '../../../utils/noop.js';
import { useContainerProps } from '../../../hooks/useContainerProps.js';
/** renders a pagination module intended for use inside a section */

var PaginationModule = function PaginationModule(props) {
  props = useContainerProps(props);

  var _props = props,
      activePage = _props.activePage,
      children = _props.children,
      collection = _props.collection,
      _props$collectionMeta = _props.collectionMeta,
      _props$collectionMeta2 = _props$collectionMeta === void 0 ? {} : _props$collectionMeta,
      total_count = _props$collectionMeta2.total_count,
      _props$loadCollection = _props.loadCollection,
      loadCollection = _props$loadCollection === void 0 ? noop : _props$loadCollection,
      _props$onPageChange = _props.onPageChange,
      onPageChange = _props$onPageChange === void 0 ? noop : _props$onPageChange,
      pageSize = _props.pageSize,
      _props$resetScroll = _props.resetScroll,
      resetScroll = _props$resetScroll === void 0 ? true : _props$resetScroll,
      _props$resultsDisplay = _props.resultsDisplayed,
      resultsDisplayed = _props$resultsDisplay === void 0 ? true : _props$resultsDisplay,
      _props$setActivePage = _props.setActivePage,
      setActivePage = _props$setActivePage === void 0 ? noop : _props$setActivePage,
      _props$hidePagination = _props.hidePagination,
      hidePagination = _props$hidePagination === void 0 ? false : _props$hidePagination;

  var handlePageChange = function handlePageChange(page) {
    setActivePage(page);
    onPageChange(page);

    if (resetScroll) {
      window.scrollTo(0, 0);
    }

    loadCollection();
  };

  var changePageSize = function changePageSize(pageSize) {
    getPageSize(pageSize);
    handlePageChange(1);
  };

  var pagingInfo = getPagingInfo({
    data: collection,
    pageSize: pageSize,
    totalCount: total_count
  });
  useEffect(function () {
    if (!activePage) {
      handlePageChange(1);
    } // Ignoring hook warning as this logic is intended to be executed on mount only.

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaginationHeader, _extends({}, props, {
    changePageSize: changePageSize,
    dataSize: pagingInfo.dataSize,
    hasPagination: pagingInfo.hasPagination,
    isLoadingData: !pagingInfo.totalCount,
    pSize: pagingInfo.pageSize,
    showPageSizeDropdown: !pageSize,
    totalCount: pagingInfo.totalCount,
    resultsDisplayed: resultsDisplayed
  })), children, !hidePagination && /*#__PURE__*/React.createElement(Pagination, _extends({}, props, {
    data: collection,
    isLoadingData: !total_count,
    onPageChange: handlePageChange,
    totalCount: total_count,
    resultsDisplayed: resultsDisplayed
  })));
};

PaginationModule.propTypes = {
  activePage: PropTypes.number,
  children: PropTypes.node,
  collection: PropTypes.array,
  collectionMeta: PropTypes.shape({
    total_count: PropTypes.number
  }),
  hidePagination: PropTypes.bool,
  loadCollection: PropTypes.func,
  maxButtons: PropTypes.number,
  onPageChange: PropTypes.func,
  pageSize: PropTypes.number,
  resetScroll: PropTypes.bool,
  resultsDisplayed: PropTypes.bool,
  setActivePage: PropTypes.func
};
export { PaginationModule };